export default __webpack_public_path__ + "static/20240228-c85b6a2aa25cdf9907696a376013189b.png";